export default "__VITE_ASSET__ace29d24__"